import React from 'react';
import { SDRMetricSection } from './SDRMetricSection';

interface SDRMetric {
  userId: string;
  userName: string;
  callsCount: number;
  callsDuration: number;
}

interface SDRPeriodColumnProps {
  title: string;
  metrics: SDRMetric[];
}

export const SDRPeriodColumn: React.FC<SDRPeriodColumnProps> = ({ 
  title, 
  metrics 
}) => {
  return (
    <div className="flex flex-col h-full">
      <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 2xl:p-10 border border-slate-700/40 shadow-lg flex-1 overflow-hidden">
        <h2 className="text-3xl 2xl:text-5xl font-bold text-slate-100 mb-6 2xl:mb-10 text-center pb-3 2xl:pb-5 border-b border-slate-600/50">
          {title}
        </h2>
        
        <SDRMetricSection
          title="Calls Count"
          metrics={metrics}
          type="count"
        />
        
        <SDRMetricSection
          title="Calls Duration"
          metrics={metrics}
          type="duration"
        />
      </div>
    </div>
  );
};